import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BASE_URL = "http://nissi-india.com";

const monthMap = {
  1: "JANUARY",
  2: "FEBRUARY",
  3: "MARCH",
  4: "APRIL",
  5: "MAY",
  6: "JUNE",
  7: "JULY",
  8: "AUGUST",
  9: "SEPTEMBER",
  10: "OCTOBER",
  11: "NOVEMBER",
  12: "DECEMBER",
};

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const PaymentAbstractReportPrint = () => {
  const q = useQuery();

  const finYearId = q.get("finYearId");
  const branchId = q.get("branchId");
  const branchType = q.get("branchType");
  const branch = q.get("branch");
  const pfnon = q.get("pfnon");
  const payment = q.get("payment");
  const grade = q.get("grade");
  const year = q.get("year");
  const monthsRaw = q.get("months") || "";

  const monthNums = monthsRaw
    .split(",")
    .map((x) => Number(x))
    .filter((n) => n >= 1 && n <= 12);

  const displayMonth = monthMap[monthNums[0]] || "";

  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({
    grosspay: 0,
    pf: 0,
    esi: 0,
    netpay: 0,
  });

  const fetchData = async () => {
    const res = await axios.get(
      `${BASE_URL}/api/payment-abstract/print-data`,
      {
        params: {
          finYearId,
          branchId,
          branchType,
          branch,
          pfnon,
          payment,
          grade,
          months: monthsRaw,
          year,
        },
      }
    );

    if (res?.data?.success) {
      setRows(res.data.rows || []);
      setTotals(res.data.totals || {});
      setTimeout(() => window.print(), 300);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      {/* PRINT CSS */}
      <style>{`
        @media print {
          body { margin: 0; }
        }

        .container {
          width: 900px;
          margin: auto;
        }

        .header-box {
          border: 1px solid black;
          padding: 10px;
        }

        .company-name {
          font-weight: bold;
          font-size: 20px;
          text-align: center;
        }

        .title-box {
          text-align: center;
          font-weight: bold;
          border-top: 1px solid black;
          border-bottom: 1px solid black;
          padding: 8px;
          margin-top: 10px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
        }

        th, td {
          border: 1px solid black;
          padding: 6px;
          font-size: 13px;
        }

        th {
          font-weight: bold;
          text-align: center;
        }

        .right { text-align: right; }
        .center { text-align: center; }
      `}</style>

      <div className="container">

        {/* HEADER */}
        <div className="header-box">
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "150px" }}>
              {/* Replace with real logo if needed */}
              <div style={{
                border: "1px solid black",
                height: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "12px"
              }}>
                LOGO
              </div>
            </div>

            <div style={{ flex: 1 }}>
              <div className="company-name">Nissi Infotech</div>
              <div style={{ textAlign: "center", fontSize: "14px" }}>
                CIVIL CONSTRUCTION
              </div>
              <div style={{ textAlign: "center", fontSize: "12px" }}>
                3/42-12, Nagappa colony, kavundampalayam. Tamil Nadu. India.
              </div>
              <div style={{ textAlign: "center", fontSize: "12px" }}>
                Phone No : 9003744644
              </div>
            </div>
          </div>
        </div>

        {/* TITLE */}
        <div className="title-box">
          PAYMENT ABSTRACT REPORT FOR THE YEAR {year}
          <div>{displayMonth}</div>
        </div>

        {/* TABLE */}
        <table>
          <thead>
            <tr>
              <th style={{ width: "60px" }}>S.No</th>
              <th>Department</th>
              <th>Gross Salary</th>
              <th>PF</th>
              <th>ESI</th>
              <th>Netpay</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan="6" className="center">
                  No Records Found
                </td>
              </tr>
            ) : (
              rows.map((r, i) => (
                <tr key={i}>
                  <td className="center">{i + 1}</td>
                  <td className="center">
                    {(r.fld_departmentname || "").toUpperCase()}
                  </td>
                  <td className="right">
                    {Number(r.grosspay || 0).toFixed(2)}
                  </td>
                  <td className="right">
                    {Number(r.pf || 0).toFixed(2)}
                  </td>
                  <td className="right">
                    {Number(r.esi || 0).toFixed(2)}
                  </td>
                  <td className="right">
                    {Number(r.netpay || 0).toFixed(2)}
                  </td>
                </tr>
              ))
            )}

            {rows.length > 0 && (
              <tr>
                <td></td>
                <td className="center"><b>Total</b></td>
                <td className="right"><b>{Number(totals.grosspay || 0).toFixed(2)}</b></td>
                <td className="right"><b>{Number(totals.pf || 0).toFixed(2)}</b></td>
                <td className="right"><b>{Number(totals.esi || 0).toFixed(2)}</b></td>
                <td className="right"><b>{Number(totals.netpay || 0).toFixed(2)}</b></td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default PaymentAbstractReportPrint;
